import { t } from 'i18next';
import { Button } from '../common/Button';
import Model from '../common/models/Model';
import { useReInviteUserToBrand } from '@/hooks/queries/useUserQueries';
import { toast } from 'react-toastify';

interface ReInviteUserModalProps {
  isReInviteModalOpen: boolean;
  setIsReInviteModalOpen: (arg: boolean) => void;
  userId: string;
  brandId: string;
  invitedUserName: string;
  invitedUserEmail: string;
  setIsLoading: (arg: boolean) => void;
}

const ReInviteUserModal: React.FC<ReInviteUserModalProps> = ({
  isReInviteModalOpen,
  setIsReInviteModalOpen,
  userId,
  brandId,
  invitedUserName,
  invitedUserEmail,
  setIsLoading,
}) => {
  const reInviteMutation = useReInviteUserToBrand(userId, brandId);

  const handleReInviteUser = async () => {
    setIsLoading(true);
    setIsReInviteModalOpen(false);
    try {
      await reInviteMutation.mutateAsync(invitedUserEmail);
      toast.success(t('userManagement.userReInviteSuccess'));
    } catch (error) {
      toast.error(t('errors.actionFailed'));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Model
      isOpen={isReInviteModalOpen}
      onClose={() => setIsReInviteModalOpen(false)}
      className="backdrop-brightness-75"
    >
      <div className="md:w-[360px]">
        <h1 className="text-2xl font-header text-[#212121]">
          {t('userManagement.actions.reInvite')}
        </h1>
        <p className="my-4 text-gray-600">
          {t('userManagement.actionsConfirmationMessage.reInviteUser')}
          &nbsp;{invitedUserName}?
        </p>
        <div className="mt-6 flex w-full items-center justify-between gap-4">
          <Button
            onClick={() => setIsReInviteModalOpen(false)}
            variant="outlined"
            className="w-[167px] h-[44px] px-0 py-0"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleReInviteUser}
            className="w-[167px] h-[44px] px-0 py-0"
          >
            {t('userManagement.actions.reInvite')}
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default ReInviteUserModal;
